<template>
  <div class="detailBox">
    <div
      style="position: absolute; z-index: 400;"
      :style="{
        left: form.x + 52 + 'px',
        top: form.y - 153 + 'px'
      }"
      class="content-box"
    >
      <div class="warn">
        <div class="title">{{ town }}</div>
        <ul>
          <li class="list-li" v-for="(item, i) in dataList" :key="i">
            <span class="point"></span>
            {{ item.name }}：
            <span class="num">{{ item.num }}</span>
            <span class="unit">({{ item.unit }})</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data() {
    return {
      town: "",
      dataList: [
        {
          name: "预期收益",
          num: 260.44,
          unit: "元"
        },
        {
          name: "实际收益",
          num: 99332,
          unit: "元"
        },
        {
          name: "预计投入资金",
          num: 153523,
          unit: "元"
        },
        {
          name: "实际投入资金",
          num: 0,
          unit: "元"
        }
      ]
    };
  },
  mounted() {
    this.setFormData(this.form.param);
  },
  methods: {
    getData(data) {
      this.$forceUpdate();
      this.$set(this.form, data);
      this.setFormData(data.param);
    },
    setFormData(param) {
      this.town = param.country + param.town;
      this.dataList[0].num = param.prospectiveEarnings;
      this.dataList[1].num = param.effectiveYield;
      this.dataList[2].num = param.expectedInvestment;
      this.dataList[3].num = param.actualInvestment;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.detailBox
  z-index 10
  color #fff
.content-box
    :before
        width 52px
        height 66px
        content ''
        position absolute
        top 20%
        left 0
        margin-left -52px
        background url('~images/map/task-line.png') no-repeat center
        background-size 100% 100%
.warn
    width 284px
    height 224px
    border-radius 5px
    box-sizing border-box
    position relative
    background url('~images/map/task-bg.png') no-repeat center
    background-size 100% 100%
//   transform translate(-52%, -192%)
    z-index 400
    :before
        content ''
        transform translate(-35%,0)
        position absolute
        bottom -9px
        left 50%
        opacity 1
        border-top solid 10px rgba(51,51,51,0.7)
        border-right solid 10px transparent
        border-left solid 10px transparent
.list-li
    font-size 14px
    padding-left 20px
    margin-top 6px
    .point
        display inline-block
        width 6px
        height 6px
        background-color #fff
        border-radius 50%
        margin-right 4px
    .num
        font-size 22px
        color #00f8fa
        margin-right 10px
.title
    width 254px
    height 40px
    line-height 40px
    padding-left 20px
    font-size 16px
    display block
    background url('~images/map/task-title-bg.png') no-repeat center
    background-size 100% 100%
</style>
